import { useRef } from "react";
import { TooltipProvider } from "./components/ui/tooltip";
import { PortalContainerProvider } from "./portal-context";
import ReplayPage from "./components/ReplayPage";

export function ReplayWidget() {
  const rootRef = useRef<HTMLDivElement>(null);
  return (
    <div ref={rootRef} className="githits-replay-root">
      <PortalContainerProvider containerRef={rootRef}>
        <TooltipProvider>
          <ReplayPage />
        </TooltipProvider>
      </PortalContainerProvider>
    </div>
  );
}
